import { useContext } from "react";
import PayloadContext from "./PayloadContext";

export const usePayloadContext = () => {
  const context = useContext(PayloadContext);
  return context;
};
